import { render } from "./DesktopFooter.vue?vue&type=template&id=1ffb455a&scoped=true"
import script from "./DesktopFooter.vue?vue&type=script&lang=js"
export * from "./DesktopFooter.vue?vue&type=script&lang=js"

import "./DesktopFooter.vue?vue&type=style&index=0&id=1ffb455a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb455a"]])

export default __exports__